import ICustomer, { ICustomerFilter, ICustomerCollection, convertToCust } from "../../../types/ICustomer";
import ICustomerService from "../../spi/ICustomerService";
import FirebaseService from "./FirebaseService";
import IPaginator, { IPaginatorQueryType, IFirebasePaginatorOperation } from "../../../types/Paginator";
import ElasticSearchService from "../elastic/ElasticSearchService";
import IActivity, { IActivityCollection, convertToActivity } from "../../../types/IActivity";

export default class FirebaseCustomerService implements ICustomerService {

  async getCustomers(pg: IPaginator, filter?: ICustomerFilter): Promise<ICustomerCollection> {
    let paginator = pg == null ? {
      type: filter == null ? IPaginatorQueryType.Firebase : IPaginatorQueryType.Elastic,
      totalPages: 0,
      pageNumber: 0,
      rowsPerPage: 6
    } : pg;
    let collection: ICustomerCollection = {
      customers: [],
      paginator: pg
    };

    try {
      if (paginator.type == IPaginatorQueryType.Elastic) {
      //   const searchResults = await new ElasticSearchService().searchCustomers(paginator.rowsPerPage, paginator.pageNumber, filter);

      //   if (searchResults && searchResults.data) {
      //     const hitsArray: any = searchResults.data.hits.hits;
      //     const totalHits: number = searchResults.data.hits.total;
      //     hitsArray.forEach((hit: any) => {
      //       const rawDoc: any = hit._source;
      //       const _id: string = hit._id;
      //       const customer: ICustomer = convertToCust(rawDoc);
      //       customer.uid = _id;
      //       collection.customers.push(customer);
      //     });
      //     collection.paginator = {
      //       type: IPaginatorQueryType.Elastic,
      //       totalPages: Math.ceil(totalHits / paginator.rowsPerPage),
      //       pageNumber: paginator.pageNumber,
      //       rowsPerPage: paginator.rowsPerPage,
      //     };
      //   }
      } else {
        let snapshot: any = null;
        if (paginator.fbOperation == IFirebasePaginatorOperation.Next) {
          snapshot = await FirebaseService.getInstance()
            .customers()
            .orderBy("name", "asc")
            .startAt(paginator.nextCursor)
            .limit(paginator.rowsPerPage)
            .get();
        } else if (paginator.fbOperation == IFirebasePaginatorOperation.Prev) {
          snapshot = await FirebaseService.getInstance()
            .customers()
            .orderBy("name", "desc")
            .startAt(paginator.prevCursor)
            .limit(paginator.rowsPerPage)
            .get();
        } else {
          snapshot = await FirebaseService.getInstance()
            .customers()
            .limit(paginator.rowsPerPage)
            .get();
        }

        if (!snapshot.empty) {
          snapshot.forEach((child: any, i: number) => {
            const key = child.id;
            const cust = child.data();
            cust.uid = key;
            //const document:IDocument = this._getIDocument(key, owner, coverTemplate, doc);
            const customer: ICustomer = convertToCust(cust);
            collection.customers.push(customer);
            if (i == 0) {
              paginator.prevCursor = child
            }
            paginator.nextCursor = child;
          });
          collection.paginator = {
            totalPages: 0,
            pageNumber: 0,
            rowsPerPage: paginator.rowsPerPage,
            type: IPaginatorQueryType.Firebase,
            prevCursor: paginator.prevCursor,
            nextCursor: paginator.nextCursor
          }

        }
      }
    } catch (e) {
      console.log(e)
      throw e;
    }
    return collection;
  }

  async getCustomerActivities(uid: string, pg: IPaginator): Promise<IActivityCollection> {
    let collection: IActivityCollection = {
      activities: [],
      paginator: pg
    };

    try {
      const snapshot = await FirebaseService.getInstance()
        .customers().doc(uid).collection('activities')
        .orderBy("time", "desc")
        //.startAt(paginator.nextCursor )
        .limit(pg.rowsPerPage)
        .get();
      if (!snapshot.empty) {
        snapshot.forEach((child: any, i: number) => {
          const key = child.id;
          const act = child.data();
          act.uid = key;
          //const document:IDocument = this._getIDocument(key, owner, coverTemplate, doc);
          const activity: IActivity = convertToActivity(act);
          collection.activities.push(activity);
          if (i == 0) {
            pg.prevCursor = child
          }
          pg.nextCursor = child;
        });
        collection.paginator = {
          totalPages: 0,
          pageNumber: 0,
          rowsPerPage: pg.rowsPerPage,
          type: IPaginatorQueryType.Firebase,
          prevCursor: pg.prevCursor,
          nextCursor: pg.nextCursor
        }
      }

    } catch (e) {
      throw e;
    }

    return collection;
  }

  async getCustomer(custId: string): Promise<ICustomer> {
    let customer: ICustomer = {} as ICustomer;
    try {
      const snapshot = await FirebaseService.getInstance()
        .customer(custId)
        .get();
      const cust: any = snapshot.data();
      const key: string = snapshot.id;
      cust.uid = key;
      customer = convertToCust(cust);
    } catch (e) {
      throw e;
    }
    return customer;
  }

  async createCustomer(cust: ICustomer): Promise<ICustomer> {
    let customer: ICustomer = {} as ICustomer;
    try {
      const { uid, ...customerSnapshot } = cust;
      debugger
      customer = await FirebaseService.getInstance().customers().doc().set(customerSnapshot);
    } catch (e) {
      console.log(e);
      throw e;
    }
    return customer;
  }

  async updateCustomer(cust: ICustomer): Promise<ICustomer> {
    let customer: ICustomer = {} as ICustomer;
    try {
      const { ...customerSnapshot } = cust;
      if (cust.uid != null) {
        await FirebaseService.getInstance()
          .customer(cust.uid)
          .update({
            ...customerSnapshot
          });
        customer = cust;
      }
    } catch (e) {
      throw e;
    }

    return customer;
  }

  async deleteCustomer(uid: string): Promise<boolean> {
    try {
      if (uid != null)
        await FirebaseService.getInstance().customers().doc(uid).delete();
    } catch (e) {
      throw e;
    }
    return true;
  }
}